/**
 * Formats the SSN string with dashes on blur event if possible.
 */
export function onBlurFormatSsn({
  event,
  onBlur,
  onChange,
}: {
  event: React.FocusEvent<HTMLInputElement>;
  onChange: (value: string) => void;
  onBlur: () => void;
}) {
  const ssnValue = event.target.value;
  if (ssnValue) {
    // Remove anything that is not a digit
    const digitsOnly = ssnValue.replace(/\D/g, "");
    // Ensure it has exactly 9 digits
    if (digitsOnly.length === 9) {
      // Format to "123-45-6789"
      const formattedSSN = `${digitsOnly.slice(0, 3)}-${digitsOnly.slice(3, 5)}-${digitsOnly.slice(5)}`;
      // Update both the input value and form state
      event.target.value = formattedSSN;
      onChange?.(formattedSSN);
    } else if (digitsOnly.length > 0) {
      // If we have digits but not exactly 9, use the filtered digits-only value
      // This helps gradually build up a valid SSN
      event.target.value = digitsOnly;
      onChange?.(digitsOnly);
    }
  }
  onBlur();
}
